import { INeoAction } from './../Actions.interface';
import { SESSION_ACTIONS } from '../../Constants/Actions.constants';

export default function SessionReducer(
  state: Record<string, { key: string; data: any }> = {},
  action: INeoAction,
) {
  const { payload, type } = action;

  if (type === SESSION_ACTIONS.SESSION_DATA) {
    return {
      ...state,
      [payload.key]: payload,
    };
  }

  if (type === SESSION_ACTIONS.DELETE_DATA) {
    const newState = { ...state };
    delete newState[payload];
    return newState;
  }

  return state;
}
